<wiz-hgroup width="100%" height="100%" gap="10">
  <!-- panneau gauche -->
  <wiz-vgroup width="338px">
    <!-- Liste des physical template -->
    <multi-display height="100%" width="100%" #multiDiplay [config]="multiConfig">
      <!-- bouton de suppression -->
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizDisabled]="canUseBatch" [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizDisabled]="canUseBatch" [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove class="image-purple" [wizTooltip]="'$.common.delete.$'" (click)="doAskForRemove()"
          [wizDisabled]="!canRemove()">delete</wiz-icon>
      </wiz-hgroup>
      <!-- bouton d'ajout -->
      <wiz-hgroup verticalAlign="center" class="add-btn" gap="10" target="title" padding="0 0 10px">
        <wiz-icon #btnCreate [wizDisabled]="!canCreate" [wizTooltip]="'$.physical-template.add.$'"
          tooltipPlacement="right" class="image-back-orange" (click)="doAct('create')">add</wiz-icon>
        <wiz-label class="titleLabel" [wizLabel]="'$.physical-template.add.$'" [wizTextBehavior]="'truncate'"
          width="100%"></wiz-label>

      </wiz-hgroup>
    </multi-display>
  </wiz-vgroup>

  <wiz-vgroup width="100%" height="100%" class="section-container-parent">
    <!-- chargeur conditionnel. Si aucun template, vue vide -->

    <wiz-hgroup [visible]="!hasCurrentTemplate" class="section-container" width="100%" height="100%"
      verticalAlign="center" horizontalAlign="center">
      <wiz-label [wizLabel]="'$.physical-template.no-template.$'" [wizTextBehavior]="'truncate'" class="componentLabel">
      </wiz-label>
    </wiz-hgroup>

    <wiz-vgroup [visible]="hasCurrentTemplate" width="100%" height="100%" gap="10">
      <wiz-hgroup width="100%" verticalAlign="end" class="section-container" padding="5px">
        <wiz-translation-basic #taDescription [wizTranslationMode]="'textarea'" [maxTranslation]="6"
          [wizLabel]="'$.common.description.$'" [wizPlaceholder]="'$.common.define.$'" width="400px"
          height="60px"></wiz-translation-basic>
        <wiz-hgroup width="50%" style="align-items: flex-end">
            <wiz-dropdown #ddScreenMode [wizLabel]="'$.screen.mode.$'" [wizDataProvider]="screenModeDS"
              [wizLabelField]="'trsLabel'" wizMandatory="true"></wiz-dropdown>
          

            <wiz-vgroup width="130px">
                  <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px"></wiz-label>
                  <wiz-hgroup verticalAlign="center">
                    <span
                      #blockBack
                      [style.backgroundColor]="backgroundColor"
                      width="20px"
                      height="20px"
                      (click)="showColorPicker($event)"
                      style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
                    ></span>
                    <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
                  </wiz-hgroup>
            </wiz-vgroup>            
          
          
            <wiz-hgroup width="170px" horizontalAlign="flex-end" style="padding-bottom: 5px">
            <wiz-button width="100%" *ngIf="canUpdateTemplates" [wizIcon]="'add'" (wizClick)="addWidget()"
              [wizLabel]="'$.phys-template.add-item.$'"></wiz-button>
          </wiz-hgroup>
        </wiz-hgroup>
            

        <wiz-hgroup width="50%" horizontalAlign="flex-end" style="align-items: flex-end; padding-bottom: 5px">
          <wiz-button [wizIcon]="'validate'" [wizLabel]="'$.common.save.$'" (wizClick)="doSaveWidget()"
            [wizDisabled]="noUpdate() || !canUpdateTemplates"></wiz-button>
          <wiz-button [wizIcon]="'view-grid'" [wizLabel]="'$.phys-template.to-tab.$'" (wizClick)="convertToTab()"
            [wizDisabled]="noWidget() || !canUpdateTemplates"></wiz-button>
          <!-- <wiz-button
            [wizIcon]="'view-grid'"
            [wizLabel]="'deepCopy'"
            (wizClick)="buildFromClone()"
          ></wiz-button> -->
        </wiz-hgroup>
      </wiz-hgroup>

      <gridster #gridster [options]="options" width="100%" height="100%" class="gridster"
        [ngStyle]="{'background-color': backgroundColor}">
        <gridster-item [item]="item" *ngFor="let item of widgets">
          <!-- attention à l'ordre des params avec les inputs... -->
          <widget-comp [model]="model" [templatingMode]="true" [itemParent]="clone" [gridsterConfig]="item"></widget-comp>
        </gridster-item>
      </gridster>
    </wiz-vgroup>
  </wiz-vgroup>
</wiz-hgroup>